import type { ApiEndpointBuilder } from "../apiEndpointHelpers";

import type {
  MessagingMergeFallbackSettings,
  MessagingMergeFallbackUpdate,
} from "@/types/adminV2/messagingMergeFallbacks";
const tag = {
  type: "AdminV2MessagingSettings",
  id: "MERGE_TAG_FALLBACKS",
} as const;
export const buildAdminV2MessagingMergeFallbackEndpoints = (
  builder: ApiEndpointBuilder,
) => ({
  getAdminV2MessagingMergeFallbacks: builder.query<
    MessagingMergeFallbackSettings,
    { ownerKey: string }
  >({
    query: () => ({
      url: "/admin/v2/messaging/settings/merge-tag-fallbacks",
      suppressAccessDeniedModal: true,
    }),
    providesTags: [tag],
    keepUnusedDataFor: 0,
  }),
  updateAdminV2MessagingMergeFallbacks: builder.mutation<
    MessagingMergeFallbackSettings,
    MessagingMergeFallbackUpdate
  >({
    query: (data) => ({
      url: "/admin/v2/messaging/settings/merge-tag-fallbacks",
      method: "PUT",
      data,
      suppressAccessDeniedModal: true,
    }),
    invalidatesTags: (result) =>
      result
        ? [tag, { type: "AdminV2MessagingSettings", id: "GLOBAL_DESIGN" }]
        : [],
  }),
});
